import { Button } from "primereact/button";
import React, { useState, useRef } from "react";
import Notification from "../../hooks/Notification";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import sendXmlService from "../../service/SendXmlApi";
import { FileUploadCom } from "./fileupload";
import "./index.css";

function TctSend() {
  const notification = new Notification();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [base64excel, setBase64excel] = useState("");
  const refFile = useRef(null);

  const sendTct = async () => {
    if (!base64excel) {
      notification.notifyWarn("Vui lòng chọn file Excel");
      return;
    }
    try {
      showLoader();
      const result = await sendXmlService.sendtctagain({ baseexcel: base64excel });
      if (result && result.status === 1000) {
        notification.notifySuccess(result.message);
      } else {
        notification.notifyError(result ? result.message : "Có lỗi xảy ra");
      }
    } catch (error) {
      notification.notifyError("Có lỗi xảy ra khi gửi");
    } finally {
      hideLoader();
      if (refFile.current) refFile.current.clear();
      setBase64excel("");
    }
  };

  return (
    <div className="sentXML">
      <div className="card">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12">
            <FileUploadCom setBase64excel={setBase64excel} refFile={refFile} />
          </div>
        </div>
        <div className="button-xml">
          <Button label="Gửi" className="p-button-success" onClick={sendTct} />
        </div>
        {loader}
      </div>
    </div>
  );
}

export default TctSend;
